<template>
    <div class="project-container">
        <div class="top-title">
            <h2>宁夏银川西夏区富宁村数字智慧温棚建设项目</h2>
        </div>

        <!-- 证书与描述区 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="8">
                <img :src="dashboardImg" alt="数字农业智能驾驶舱" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="14">
                <div class="desc-card">
                    <p>
                        我公司于2023年开始实施宁夏银川西夏区富宁村数字智慧温棚建设项目，该项目以物联网与大数据技术为核心，建设标准化智能温棚36座，覆盖面积240余亩。通过部署环境监测传感器、智能水肥一体化系统、自动化卷帘/通风控制终端及云端集控大屏平台，实现温棚内光照、温湿度、二氧化碳浓度等参数实时监测与智能调控，精准匹配作物生长需求。同时，结合农事管理数字化系统，规范种植流程，减少人工成本35%以上。
                    </p>
                    <p>
                        项目落地后，成为西夏区设施农业数字化改造样板，获地方政府表彰推广，并吸引周边市县农业企业观摩，助力富宁村从传统种植向“数据驱动”智慧农业转型。
                    </p>
                </div>
            </el-col>
        </el-row>

        <!-- 底部图片展示区 -->
        <div class="image-grid">
            <el-row :gutter="15">
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/fncone.png" alt="" class="project-img">
                    <p class="img-p">
                        我公司建设完毕的室外气象站
                    </p>

                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/fncthree.png" alt="" class="project-img">
                    <p class="img-p">棚户使用我公司产品为种植带来了实际效益</p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/fncfour.png" alt="" class="project-img">
                    <p class="img-p">配备我公司生产的智能水肥一体机</p>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NingxiaProjectPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/MainTypicalcase/fnctwo.png')

        }
    }
}
</script>